import { Component } from '@angular/core';
import { EnumScales } from '@library/store/measures/measures.interface';
import { EnergyReport } from '@store/energy-reports/energy-reports.interface';
import { isDefined } from '@library/utils/helpers/store/is-defined';
import { EnergyReportsFacade } from '@store/energy-reports/energy-reports.facade';
import { combineLatest } from 'rxjs';
import { CpReportsScaleService } from '../../cp-reports-month-viewer/cp-reports-scale-selector/cp-reports-scale.service';

@Component({
  selector: 'app-cp-reports-factors-content',
  templateUrl: './cp-reports-factors-content.component.html',
  styleUrl: './cp-reports-factors-content.component.scss'
})
export class CpReportsFactorsContentComponent {

  report$ = this.energyReportsFacade.currentReport$.pipe(isDefined());

  viewModel$ = combineLatest({
    report: this.report$,
    scale: this.cpReportsScaleService.scale$,
  });

  EnumScales = EnumScales;

  constructor(
    private energyReportsFacade: EnergyReportsFacade,
    private cpReportsScaleService: CpReportsScaleService,
  ) { }

  hasExternalTemperature(report: EnergyReport, scale: EnumScales) {
    if (scale === EnumScales.YEAR) {
      return report.average_external_temperature && report.external_temperature_difference_previous_year;
    }
    else {
      return report.average_external_temperature && report.external_temperature_difference_previous_month;
    }
  }

  hasInternalTemperature(report: EnergyReport, scale: EnumScales) {
    if (scale === EnumScales.YEAR) {
      return report.average_internal_temperature && report.internal_temperature_difference_previous_year;
    }
    else {
      return report.average_internal_temperature && report.internal_temperature_difference_previous_month;

    }
  }
}
